// src/pages/ForgotPassword.js

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// On importe les deux fonctions Amplify nécessaires
import { resetPassword, confirmResetPassword } from 'aws-amplify/auth';

function ForgotPassword() {
  // --- États pour les champs et la gestion des étapes ---
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [step, setStep] = useState('request'); // 'request' ou 'confirm'

  const navigate = useNavigate();

  // --- Étape 1 : Demander le code de réinitialisation ---
  const handleRequestCode = async (e) => {
    e.preventDefault();
    setError('');
    try {
      // On demande à Cognito d'envoyer un code à l'e-mail de l'utilisateur
      await resetPassword({ username: email });
      // Si la demande réussit, on passe à l'étape suivante
      setStep('confirm');
    } catch (err) {
      setError(err.message);
    }
  };

  // --- Étape 2 : Confirmer le nouveau mot de passe ---
  const handleConfirmReset = async (e) => {
    e.preventDefault();
    setError('');
    try {
      // On envoie le code et le nouveau mot de passe à Cognito
      await confirmResetPassword({ 
        username: email, 
        confirmationCode: code, 
        newPassword: newPassword 
      });
      // Si tout est bon, on redirige vers la page de connexion avec un message de succès
      navigate('/connexion', { state: { message: 'Mot de passe réinitialisé avec succès !' } });
    } catch (err) {
      setError(err.message);
    }
  };

  // --- Rendu JSX du composant ---
  return (
    <section className="login-section">
      <div className="login-container">
        {step === 'request' ? (
          // --- Formulaire de demande de code ---
          <>
            <h2>Mot de passe oublié</h2>
            <p style={{textAlign: 'center', marginBottom: '1.5rem', fontSize: '15px', color: '#666'}}>
              Entrez votre adresse e-mail. Nous vous enverrons un code pour réinitialiser votre mot de passe.
            </p>
            <form className="login-form" onSubmit={handleRequestCode}>
              <input
                type="email"
                placeholder="Adresse e-mail"
                aria-label="Adresse e-mail"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {error && <p style={{ color: 'red' }}>{error}</p>}
              <button type="submit">Envoyer le code</button>
            </form>
          </>
        ) : (
          // --- Formulaire de confirmation ---
          <>
            <h2>Réinitialiser le mot de passe</h2>
            <p style={{textAlign: 'center', marginBottom: '1.5rem', fontSize: '15px', color: '#666'}}>
              Un code a été envoyé à l'adresse e-mail associée à ce compte.
            </p>
            <form className="login-form" onSubmit={handleConfirmReset}>
              <input
                type="text"
                placeholder="Code de vérification"
                aria-label="Code de vérification"
                required
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
              <input
                type="password"
                placeholder="Nouveau mot de passe"
                aria-label="Nouveau mot de passe"
                required
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              {error && <p style={{ color: 'red' }}>{error}</p>}
              <button type="submit">Changer le mot de passe</button>
            </form>
          </>
        )}
        <p className="login-footer">
          Retourner à la page de <Link to="/connexion">connexion</Link>
        </p>
      </div>
    </section>
  );
}

export default ForgotPassword;